const Measurements = {
  float: 'float',
  integer: 'integer',
};

export default Measurements;
